const DELETE_ICON = `<svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
>
    <path d="M10 11V17" stroke="currentColor" stroke-width="1.56" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M14 11V17" stroke="currentColor" stroke-width="1.56" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M4 7H20" stroke="currentColor" stroke-width="1.56" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke="currentColor" stroke-width="1.56" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="currentColor" stroke-width="1.56" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

function initCartSFL(swat) {
    const SFL_STATE = { 
        listId: null,
        items: [],
        hasFetched: false,
        productCache: {},
        initPromise: null
    };

    const getHandleFromUrl = (url) => {
        try {
            const pathParts = new URL(url, window.location.origin).pathname.split('/');
            const idx = pathParts.indexOf('products');
            return (idx !== -1 && pathParts.length > idx + 1) ? pathParts[idx + 1] : null;
        } catch (e) {
            return null;
        }
    };

    const fetchShopifyProduct = async (handle) => {
        if (!handle) return null;

        if (!SFL_STATE.productCache[handle]) {
            SFL_STATE.productCache[handle] = fetch(
                `${window.Shopify.routes.root}products/${handle}.js`
            )
                .then((res) => {
                    if (!res.ok) {
                        throw new Error("Product not found");
                    }
                    return res.json();
                })
                .catch((err) => {
                    delete SFL_STATE.productCache[handle];
                    console.error(`[Swym SFL] Shopify fetch error for ${handle}:`, err);
                    return null;
                });
        }

        return await SFL_STATE.productCache[handle];
    };

    const ensureSflListReady = () => {
        if (SFL_STATE.listId) return Promise.resolve(SFL_STATE.listId);
        
        if (SFL_STATE.initPromise) return SFL_STATE.initPromise;

        SFL_STATE.initPromise = new Promise((resolve, reject) => {
            swat.SaveForLater.init(
                (initRes) => {
                    const lid = initRes.listid || initRes.list.lid;
                    SFL_STATE.listId = lid;
                    resolve(lid);
                },
                (error) => {
                    console.error("[Swym SFL] Failed to initialize:", error);
                    SFL_STATE.initPromise = null;
                    reject(error);
                }
            );
        });

        return SFL_STATE.initPromise;
    };

    const fetchAndRenderSFL = async () => {
        if (SFL_STATE.hasFetched) {
            renderSFLSlider(SFL_STATE.items);
            return;
        }

        const sflContainer = document.getElementById("swym-sfl-container");
        if (sflContainer && sflContainer.dataset.isEmpty !== "true") {
            sflContainer.dataset.updating = "true";
        }

        try {
            const lid = await ensureSflListReady();

            const [fetchRes, cartData] = await Promise.all([
                new Promise((resolve, reject) => {
                    swat.SaveForLater.fetch(lid, resolve, reject);
                }),
                fetch(window.Shopify.routes.root + "cart.js").then(res => res.json())
            ]);

            SFL_STATE.hasFetched = true;
            const rawItems = fetchRes.items || [];
            
            const cartVariantIds = new Set(cartData.items.map(item => item.variant_id || item.id));
            
            const itemsToKeep = [];
            const itemsToRemoveFromSwym = [];

            rawItems.forEach(item => {
                const variantId = parseInt(item.epi, 10);
                if (cartVariantIds.has(variantId)) {
                    itemsToRemoveFromSwym.push({
                        du: item.du,
                        empi: item.empi,
                        epi: item.epi
                    });
                } else {
                    itemsToKeep.push(item);
                }
            });

            if (itemsToRemoveFromSwym.length > 0) {
                swat.SaveForLater.remove(
                    lid, 
                    itemsToRemoveFromSwym, 
                    () => console.log("[Swym SFL] Synced: Removed cart items from SFL list"),
                    (err) => console.error("[Swym SFL] Sync Error:", err)
                );
            }

            SFL_STATE.items = itemsToKeep.map(item => ({ ...item, _isShopifyHydrated: false }));
            renderSFLSlider(SFL_STATE.items);

            itemsToKeep.forEach(async (item) => {
                const handle = getHandleFromUrl(item.du);
                const shopifyProduct = await fetchShopifyProduct(handle);
                
                if (shopifyProduct) {
                    const variantId = parseInt(item.epi, 10);
                    const variant = shopifyProduct.variants.find(v => v.id === variantId) || shopifyProduct.variants[0];

                    const stateIndex = SFL_STATE.items.findIndex(i => i.epi === item.epi);
                    if (stateIndex !== -1) {
                        SFL_STATE.items[stateIndex] = {
                            ...item,
                            dt: shopifyProduct.title,
                            vi: variant.title && variant.title !== "Default Title" ? variant.title : "",
                            pr: variant.price,
                            capr: variant.compare_at_price,
                            iu: variant.featured_image?.src || shopifyProduct.featured_image || item.iu,
                            available: variant.available,
                            _isShopifyHydrated: true
                        };
                        
                        updateSlideDOM(SFL_STATE.items[stateIndex]);
                    }
                }
            });

        } catch (err) {
            console.error("[Swym SFL] Failed to fetch and render list:", err);
            if (sflContainer) sflContainer.dataset.updating = "false";
        }
    };

    const updateSlideDOM = (item) => {
        const slide = document.querySelector(`.swiper-slide[data-slide-epi="${item.epi}"]`);
        if (!slide) return; 

        const sflContainer = document.getElementById("swym-sfl-container");
        const moveToCartBtnText = sflContainer.getAttribute('data-move_to_cart_label') || 'Add to Cart';
        const outOfStockBtnText = sflContainer.getAttribute('data-out_of_stock_button_label') || 'Not Available';

        const safeTitle = item.dt ? item.dt.replace(/"/g, '&quot;') : 'Product';
        const safeVariant = item.vi ? item.vi.replace(/"/g, '&quot;') : '';

        const title = slide.querySelector('.product-name');
        if (title) { title.textContent = item.dt; title.title = item.dt; }
        
        const img = slide.querySelector('.product-img img');
        if (img) { img.src = item.iu; img.alt = safeTitle; }

        const variantContainer = slide.querySelector('.product-variant');
        if (variantContainer) {
            variantContainer.classList.remove('skeleton-box', 'skeleton-variant');
            variantContainer.textContent = item.vi;
        }

        const pricingContainer = slide.querySelector('.product-pricing');
        if (pricingContainer) {
            const price = Utils.formatMoney(item.pr);
            const compareAtPrice = item.capr && Number(item.capr) > Number(item.pr) ? Utils.formatMoney(item.capr) : "";
            pricingContainer.innerHTML = `
                <span class="sale-price">${price}</span>
                ${compareAtPrice ? `<span class="original-price">${compareAtPrice}</span>` : ""}
            `;
        }

        const addToCartBtn = slide.querySelector('.add-to-cart-btn');
        if (addToCartBtn) {
            const buttonText = item.available === false ? outOfStockBtnText : moveToCartBtnText;
            addToCartBtn.className = "btn btn-primary add-to-cart-btn"; 
            addToCartBtn.disabled = item.available === false;
            addToCartBtn.textContent = buttonText;
            addToCartBtn.title = buttonText;
            
            addToCartBtn.setAttribute('data-dt', safeTitle);
            addToCartBtn.setAttribute('data-vi', safeVariant);
            addToCartBtn.setAttribute('data-epi', item.epi);
            addToCartBtn.setAttribute('data-empi', item.empi);
            addToCartBtn.setAttribute('data-du', item.du);
        }

        const removeBtn = slide.querySelector('.remove-product-btn');
        if (removeBtn) {
            removeBtn.setAttribute('data-dt', safeTitle);
            removeBtn.setAttribute('data-vi', safeVariant);
            removeBtn.setAttribute('data-epi', item.epi);
            removeBtn.setAttribute('data-empi', item.empi);
            removeBtn.setAttribute('data-du', item.du);
        }
    };

    const renderSFLSlider = (items) => {
        const sflContainer = document.getElementById("swym-sfl-container");
        const wrapper = document.getElementById("swym-sfl-wrapper");

        if (!sflContainer || !wrapper) return;

        sflContainer.dataset.updating = "false";

        if (items.length === 0) {
            sflContainer.style.display = "none";
            sflContainer.dataset.isEmpty = "true";
            wrapper.innerHTML = "";
            return;
        }

        const moveToCartBtnText = sflContainer.getAttribute('data-move_to_cart_label') || 'Add to Cart';
        const outOfStockBtnText = sflContainer.getAttribute('data-out_of_stock_button_label') || 'Not Available';
        sflContainer.dataset.isEmpty = "false";

        wrapper.innerHTML = items.map(item => {
            const safeTitle = item.dt ? item.dt.replace(/"/g, '&quot;') : 'Product';
            const isHydrated = item._isShopifyHydrated !== false; 
            
            let priceHtml = '';
            let variantHtml = '';
            let buttonHtml = '';

            if (!isHydrated) {
                priceHtml = `<span class="skeleton-box skeleton-price"></span>`;
                variantHtml = `<p class="product-variant skeleton-box skeleton-variant"></p>`;
                buttonHtml = `
                    <button class="btn btn-primary add-to-cart-btn skeleton-box skeleton-btn" disabled>
                        Loading...
                    </button>
                `;
            } else {
                const price = Utils.formatMoney(item.pr);
                const compareAtPrice = item.capr && Number(item.capr) > Number(item.pr) ? Utils.formatMoney(item.capr) : "";
                const buttonText = item.available === false ? outOfStockBtnText : moveToCartBtnText;
                const buttonDisabledState = item.available === false ? "disabled" : "";
                const safeVariant = item.vi ? item.vi.replace(/"/g, '&quot;') : '';

                priceHtml = `
                    <span class="sale-price">${price}</span>
                    ${compareAtPrice ? `<span class="original-price">${compareAtPrice}</span>` : ""}
                `;
                variantHtml = `<p class="product-variant">${item.vi}</p>`;
                buttonHtml = `
                    <button
                        class="btn btn-primary add-to-cart-btn"
                        data-epi="${item.epi}"
                        data-empi="${item.empi}"
                        data-du="${item.du}"
                        data-dt="${safeTitle}" 
                        data-vi="${safeVariant}"
                        title="${buttonText}"
                        ${buttonDisabledState}
                    >
                        ${buttonText}
                    </button>
                `;
            }

            return `
                <div class="swiper-slide swym-sfl-item" data-slide-epi="${item.epi}">
                    <div class="sfl-product-card">
                        <div class="product-img">
                            <a href="${item.du}">
                                <img src="${item.iu}" alt="${safeTitle}">
                            </a>
                        </div>
                        <div class="product-info">
                            <a href="${item.du}"><p class="product-name" title="${item.dt || 'Product'}">${item.dt || 'Product'}</p></a>
                            ${variantHtml}
                            <div class="product-pricing">
                                ${priceHtml}
                            </div>
                            <div class="buttons-wrapper">
                                ${buttonHtml}
                                <button
                                    class="btn btn-secondary remove-product-btn"
                                    data-epi="${item.epi}"
                                    data-empi="${item.empi}"
                                    data-du="${item.du}"
                                    data-dt="${safeTitle}" 
                                    title="Remove"
                                >
                                    ${DELETE_ICON}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }).join('');

        sflContainer.style.display = "block";

        if (sflContainer.swiperInstance) sflContainer.swiperInstance.destroy(true, true);
        
        sflContainer.swiperInstance = new Swiper("#swym-sfl-swiper", {
            slidesPerView: 1.25,
            spaceBetween: 16,
            navigation: {
                nextEl: "#swym-sfl-container .swiper-button-next",
                prevEl: "#swym-sfl-container .swiper-button-prev",
            },
            breakpoints: {
                375: { slidesPerView: 2 },
                480: { slidesPerView: 2.75 },
                667: { slidesPerView: 3.5 },
                750: { slidesPerView: 1.2},
                860: { slidesPerView: 1.5},
                991: { slidesPerView: 'auto', spaceBetween: 10 },
            },
        });
    };

    if (!window.swymSflMoveListenerAttached) {
        document.addEventListener("click", async (e) => {
            const sflAddToCartBtn = e.target.closest(".add-to-cart-btn");
            if (!sflAddToCartBtn || sflAddToCartBtn.disabled) return;

            e.preventDefault();
            const card = sflAddToCartBtn.closest(".sfl-product-card");
            const sflRemoveProductBtn = card.querySelector(".remove-product-btn");

            sflAddToCartBtn.disabled = true;
            sflRemoveProductBtn.disabled = true;
            sflAddToCartBtn.classList.add("custom-btn-loader");

            const variantId = parseInt(
                sflAddToCartBtn.getAttribute("data-epi"),
                10
            );
            const productName = sflAddToCartBtn.getAttribute("data-dt");
            const variantName = sflAddToCartBtn.getAttribute("data-vi");
            const toastMessage = variantName
                ? `${productName} (${variantName}) added to the cart`
                : `${productName} added to the cart`;

            try {
                await fetch(window.Shopify.routes.root + "cart/add.js", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                            },
                        ],
                    }),
                });

                try {
                    await removeProductFromSFL(sflAddToCartBtn);
                    window.customShowToast("ShowToast", toastMessage);
                    window.location.reload();
                } catch (err) {
                    sflAddToCartBtn.disabled = false;
                    sflRemoveProductBtn.disabled = false;
                    sflAddToCartBtn.classList.remove("custom-btn-loader");
                    window.customShowToast("ShowToast", "Failed to remove item from list");
                }
            } catch (err) {
                sflAddToCartBtn.disabled = false;
                sflRemoveProductBtn.disabled = false;
                sflAddToCartBtn.classList.remove("custom-btn-loader");
                window.customShowToast("ShowToast", "Failed to add item to cart");
            }
        });
        window.swymSflMoveListenerAttached = true;
    }

    if (!window.swymSflDeleteListenerAttached) {
        document.addEventListener("click", async (e) => {
            const sflRemoveProductBtn = e.target.closest(".remove-product-btn");
            if (!sflRemoveProductBtn) return;

            e.preventDefault();

            const card = sflRemoveProductBtn.closest(".sfl-product-card");
            const sflAddToCartBtn = card.querySelector(".add-to-cart-btn");

            sflAddToCartBtn.disabled = true;
            sflRemoveProductBtn.disabled = true;
            sflRemoveProductBtn.classList.add("custom-btn-loader");

            const productName = sflRemoveProductBtn.getAttribute("data-dt");
            const variantName = sflRemoveProductBtn.getAttribute("data-vi");
            const toastMessage = variantName
                ? `${productName} (${variantName}) removed from saved for later`
                : `${productName} removed from saved for later`;

            try {
                await removeProductFromSFL(sflRemoveProductBtn);
                window.customShowToast("ShowToast", toastMessage);
            } catch (err) {
                console.error("[Swym SFL] Remove Error:", err);
                sflAddToCartBtn.disabled = false;
                sflRemoveProductBtn.disabled = false;
                sflRemoveProductBtn.classList.remove("custom-btn-loader");
                window.customShowToast("ShowToast", "Failed to remove item");
            }
        });

        window.swymSflDeleteListenerAttached = true;
    }

    const removeProductFromSFL = (btn) => {
        return new Promise((resolve, reject) => {
            const variantId = parseInt(btn.getAttribute("data-epi"), 10);
            const empi = parseInt(btn.getAttribute("data-empi"), 10);
            const du = btn.getAttribute("data-du");

            const productToRemove = [{
                du,
                empi,
                epi: variantId
            }];

            swat.SaveForLater.remove(
                SFL_STATE.listId,
                productToRemove,
                () => {
                    SFL_STATE.items = SFL_STATE.items.filter(
                        item => parseInt(item.epi, 10) !== variantId
                    );

                    renderSFLSlider(SFL_STATE.items);
                    resolve();
                },
                (err) => {
                    reject(err);
                }
            );
        });
    };

    const attachCartLineItemEvents = () => {
        document.querySelectorAll(".cart-items__details").forEach((container, index) => {
            const wrapper = container.querySelector(".cart-buttons-wrapper");
            const sflBtn = container.querySelector(".cart-sfl-btn");

            if (sflBtn && !sflBtn.dataset.listenerAttached) {
                sflBtn.dataset.listenerAttached = "true";
                sflBtn.addEventListener("click", async (e) => {
                    e.preventDefault();

                    const linkElem = container.querySelector(".cart-items__title");
                    if (!linkElem) return;

                    sflBtn.disabled = true;
                    sflBtn.classList.add('custom-btn-loader');

                    try {
                        const validListId = await ensureSflListReady();

                        const [path, query] = linkElem.getAttribute("href").split("?");
                        const domVariantId = parseInt(new URLSearchParams(query).get("variant"), 10);
                        const cleanPath = window.location.origin + path;
                        const handle = getHandleFromUrl(cleanPath);
                        const shopifyProduct = await fetchShopifyProduct(handle);
                        
                        if (!shopifyProduct) {
                            return resetSflBtn(sflBtn);
                        }

                        const variant = shopifyProduct.variants.find(v => v.id === domVariantId) || shopifyProduct.variants[0];
                        
                        const swymPayload = {
                            epi: parseInt(variant.id, 10), 
                            empi: parseInt(shopifyProduct.id, 10),
                            du: cleanPath, 
                            dt: shopifyProduct.title,
                            iu: variant.featured_image?.src || shopifyProduct.featured_image,
                            pr: variant.price,
                            vi: variant.title && variant.title !== "Default Title" ? variant.title : ""
                        };

                        const localStateProduct = {
                            ...swymPayload,
                            available: variant.available
                        };

                        swat.SaveForLater.add(validListId, [swymPayload], res => {
                            if (res.itemsadded?.length > 0) {
                                const item = res.itemsadded[0];
                                window.customShowToast("ShowToast", `${item.vi ? `${item.dt} (${item.vi})` : item.dt} saved for later`);
                                removeNativeCartItem(container, index, swymPayload.epi);
                                
                                requestAnimationFrame(() => {
                                    document.body.classList.remove("swym-modal-active");
                                    document.body.style.removeProperty("overflow");
                                });
                            } else {
                                resetSflBtn(sflBtn);
                                window.customShowToast("ShowToast", "Failed to save. Please try again.");
                            }
                        }, () => {
                            resetSflBtn(sflBtn);
                            window.customShowToast("ShowToast", "Failed to save. Please try again.");
                        });

                    } catch (err) {
                        console.error("[Swym SFL] Initialization failed, cannot save:", err);
                        resetSflBtn(sflBtn);
                        window.customShowToast("ShowToast", "Service unavailable right now.");
                    }
                });
            }

            if(wrapper) {
                new MutationObserver(() => {
                    const warrantyBtn = container.querySelector(".sb-sennheiser-cartCTA");
                    if (warrantyBtn && warrantyBtn.parentElement !== wrapper) wrapper.appendChild(warrantyBtn);
                }).observe(container, { childList: true, subtree: true });
            }
        });
    };

    const resetSflBtn = (btn) => {
        btn.disabled = false;
        btn.classList.remove('custom-btn-loader')
    };

    const removeNativeCartItem = (container, index, variantId) => {
        container.style.opacity = '0.5';
        container.style.pointerEvents = 'none';

        const stringifiedId = String(variantId);
        fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST", 
            headers: { 
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({ id: stringifiedId, quantity: 0 }),
        })
        .then((response) => {
            if (!response.ok) throw new Error("Network response was not ok");
            return response.json();
        })
        .then(() => {
            window.location.reload();
        })
        .catch((err) => {
            console.error("[Swym SFL] Failed to remove native cart item:", err);
            window.location.reload();
        });
    };

    const cartObserver = new MutationObserver(() => {
        const sflContainer = document.getElementById("swym-sfl-container");

        if (sflContainer && sflContainer.style.display === "none") {
            if (sflContainer.dataset.isEmpty !== "true" && sflContainer.dataset.updating !== "true") {
                sflContainer.dataset.updating = "true";
                
                if (SFL_STATE.hasFetched) {
                    renderSFLSlider(SFL_STATE.items);
                } else {
                    fetchAndRenderSFL();
                }
            }
        }

        attachCartLineItemEvents();
    });

    const cartItemsWrapper = document.querySelector('.cart-items__wrapper');
    if (cartItemsWrapper) {
        cartObserver.observe(cartItemsWrapper, { childList: true, subtree: true });
    }

    const observer = new MutationObserver(() => {
        if (document.body.classList.contains("swym-modal-active")) {
            const pageName = window.location.pathname.split("/").filter(Boolean).pop();
            if(pageName === 'cart') document.body.classList.remove("swym-modal-active")
        }
    });

    observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["class"]
    });

    fetchAndRenderSFL();
    attachCartLineItemEvents();
}

function initSwymSflApp(swat) {
    if (document.getElementById("swym-sfl-container")) {
        initCartSFL(swat);
    }
}

if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
}
window.SwymCallbacks.push(initSwymSflApp);